export default __webpack_public_path__ + "static/media/FileAdmin.e5c06007.svg";